<template>
  <div class="navigation" v-if="amountPage > 0">
    <div v-if="countRow > 1" class="pagination-onpage">
      <span>На странице:</span>
      <nav>
        <ul class="pagination">
          <li class="page-item" :class="{ 'active' : perPageNow == 10}" v-if="countRow >= 1" @click="perPage(10)">
            <a class="page-link" href="javascript: void(0)">10</a>
          </li>
          <li class="page-item" :class="{ 'active' : perPageNow == 25}" v-if="countRow >= 25" @click="perPage(25)">
            <a class="page-link" href="javascript: void(0)">25</a>
          </li>
          <li class="page-item" :class="{ 'active' : perPageNow == 50}" v-if="countRow >= 50" @click="perPage(50)">
            <a class="page-link" href="javascript: void(0)">50</a>
          </li>
          <li class="page-item" :class="{ 'active' : perPageNow == 100}" v-if="countRow >= 100" @click="perPage(100)">
            <a class="page-link" href="javascript: void(0)">100</a>
          </li>
          <li class="page-item" :class="{ 'active' : perPageNow == 200}" v-if="countRow >= 200" @click="perPage(200)">
            <a class="page-link" href="javascript: void(0)">200</a>
          </li>
        </ul>
      </nav>
    </div>
    <div>
      <span>Перейти на страницу:</span>
      <nav>
        <ul class="pagination" v-if="amountPage < 13">
          <li class="page-item" v-for="page in amountPage" v-bind:key="page"
              :class="{ 'active' : currentPage == page}" @click="goToPage(page)">
            <a class="page-link" href="javascript: void(0)">{{ page }}</a>
          </li>
        </ul>

        <ul class="pagination" v-else>
          <li v-if="currentPage > 4" class="page-item" @click="goToPage(1)"
              :class="{ 'active' : currentPage == 1}">
            <a class="page-link" href="javascript: void(0)">1</a>
          </li>
          <li v-if="currentPage > 5" class="page-item" @click="goToPage(2)"
              :class="{ 'active' : currentPage == 2}">
            <a class="page-link" href="javascript: void(0)">2</a>
          </li>
          <li v-if="currentPage > 6" class="page-item" @click="goToPage(3)"
              :class="{ 'active' : currentPage == 3}">
            <a class="page-link" href="javascript: void(0)">3</a>
          </li>
          <li v-if="currentPage > 4" class="page-item">
            <a class="page-link" href="javascript: void(0)">...</a>
          </li>

          <li class="page-item" v-for="page in sevenFromCurrentPage" v-bind:key="page" @click="goToPage(page)"
              :class="{ 'active' : currentPage == page}">
            <a class="page-link" v-if="page > (currentPage - 4) && page < (currentPage + 4)"
               href="javascript: void(0)">{{ page }}</a>
          </li>

          <li v-if="(amountPage - currentPage) >= 4" class="page-item">
            <a class="page-link" href="javascript: void(0)">...</a>
          </li>
          <li v-if="(amountPage - currentPage) >= 6" class="page-item" @click="goToPage((amountPage - 2))"
              :class="{ 'active' : currentPage == (amountPage - 2)}">
            <a class="page-link" href="javascript: void(0)">{{ (amountPage - 2) }}</a>
          </li>
          <li v-if="(amountPage - currentPage) >= 5" class="page-item" @click="goToPage((amountPage - 1))"
              :class="{ 'active' : currentPage == (amountPage - 1)}">
            <a class="page-link" href="javascript: void(0)">{{ (amountPage - 1) }}</a>
          </li>
          <li v-if="(amountPage - currentPage) >= 4" class="page-item" @click="goToPage((amountPage))"
              :class="{ 'active' : currentPage == amountPage}">
            <a class="page-link" href="javascript: void(0)">{{ (amountPage) }}</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    currentPage: Number,
    countRow: Number,
    perPageNow: Number,
    goToPage: Function,
    perPage: Function,
  },
  computed: {
    amountPage: function () {
      return Math.ceil(this.countRow / this.perPageNow);
    },
    sevenFromCurrentPage: function () {
      let seven = []

      if (this.currentPage > 3)
        seven.push(this.currentPage - 3)
      if (this.currentPage > 2)
        seven.push(this.currentPage - 2)
      if (this.currentPage > 1)
        seven.push(this.currentPage - 1)

      seven.push(this.currentPage)

      if (this.currentPage + 1 <= this.amountPage)
        seven.push(this.currentPage + 1)
      if (this.currentPage + 2 <= this.amountPage)
        seven.push(this.currentPage + 2)
      if (this.currentPage + 3 <= this.amountPage)
        seven.push(this.currentPage + 3)

      return seven
    }

  }
}
</script>

<style scoped>
.navigation div {
  float: left;
}

.navigation nav {
  float: right;
}

.navigation span {
  padding-right: 30px;
}

.navigation {
  line-height: 2.4;
}

.brand .datepicker {
  height: 31px !important;
}

.navigation .export-nav {
  float: right;
}

.pagination-onpage {
  padding-right: 30px;
}
</style>